import { render, staticRenderFns } from "./Issue.vue?vue&type=template&id=5b99a540&"
import script from "./Issue.vue?vue&type=script&lang=ts&"
export * from "./Issue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports